import React, {Component} from 'react'

class ProductTitle extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            size: this.props.size || 'medium',
            className: this.props.className || '',
            style: this.props.style || {},
            onClick: this.props.onClick || function(){},
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            size: nextProps.size || 'medium',
            className: nextProps.className || '',
            style: nextProps.style || {},
            onClick: nextProps.onClick || function(){},
        })
    }

    render() {
        switch (this.state.size) {
            case 'small':
                return <h6 className={this.state.className} style={this.state.style} onClick={this.state.onClick}>
                    {this.props.children}
                </h6>
            case 'large':
                return <h4 className={this.state.className} style={this.state.style} onClick={this.state.onClick}>
                    {this.props.children}
                </h4>
        }
        return (
            <h5 className={this.state.className} style={this.state.style} onClick={this.state.onClick}>
                {this.props.children}
            </h5>
        );
    }
}

export default ProductTitle


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/producttitle.component.jsx